import { NextPage, NextPageContext } from "next";
import dynamic from "next/dynamic";
import Auth from "@layouts/Auth";
import { canonicalLink } from "@helpers/url";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { localeKey } from "@constants/locale-key";

const PageConfirmNewPassword = dynamic(
  () => {
    return import("@containers/ConfirmNewPassword/ConfirmNewPassword");
  },
  { ssr: false },
);

const ConfirmNewPasswordPage: NextPage = () => {
  return (
    <Auth title="Lupa Password - Password Baru">
      <PageConfirmNewPassword />
    </Auth>
  );
};

export async function getServerSideProps({ locale }: NextPageContext) {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? "id", localeKey)),
      title: "Konfirmasi Password Baru",
      description: "Jangan bagikan password kepada siapa pun untuk melindungi akun Anda.",
      imageUrl: "https://storage-assurance-dev.mytens.id/assets/mytenscustomer/bglogin.png",
      canonical: canonicalLink("/lupa-password/konfirmasi-password-baru", locale),
    },
  };
}

export default ConfirmNewPasswordPage;
